/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { TaskWorkflowItemConfigurationTargetingOneOf } from './TaskWorkflowItemConfigurationTargetingOneOf';
import {
    instanceOfTaskWorkflowItemConfigurationTargetingOneOf,
    TaskWorkflowItemConfigurationTargetingOneOfFromJSON,
    TaskWorkflowItemConfigurationTargetingOneOfFromJSONTyped,
    TaskWorkflowItemConfigurationTargetingOneOfToJSON,
} from './TaskWorkflowItemConfigurationTargetingOneOf';
import type { TaskWorkflowItemConfigurationTargetingOneOf1 } from './TaskWorkflowItemConfigurationTargetingOneOf1';
import {
    instanceOfTaskWorkflowItemConfigurationTargetingOneOf1,
    TaskWorkflowItemConfigurationTargetingOneOf1FromJSON,
    TaskWorkflowItemConfigurationTargetingOneOf1FromJSONTyped,
    TaskWorkflowItemConfigurationTargetingOneOf1ToJSON,
} from './TaskWorkflowItemConfigurationTargetingOneOf1';
import type { TaskWorkflowItemConfigurationTargetingOneOf2 } from './TaskWorkflowItemConfigurationTargetingOneOf2';
import {
    instanceOfTaskWorkflowItemConfigurationTargetingOneOf2,
    TaskWorkflowItemConfigurationTargetingOneOf2FromJSON,
    TaskWorkflowItemConfigurationTargetingOneOf2FromJSONTyped,
    TaskWorkflowItemConfigurationTargetingOneOf2ToJSON,
} from './TaskWorkflowItemConfigurationTargetingOneOf2';
import type { TaskWorkflowItemConfigurationTargetingOneOf3 } from './TaskWorkflowItemConfigurationTargetingOneOf3';
import {
    instanceOfTaskWorkflowItemConfigurationTargetingOneOf3,
    TaskWorkflowItemConfigurationTargetingOneOf3FromJSON,
    TaskWorkflowItemConfigurationTargetingOneOf3FromJSONTyped,
    TaskWorkflowItemConfigurationTargetingOneOf3ToJSON,
} from './TaskWorkflowItemConfigurationTargetingOneOf3';

/**
 * @type TaskWorkflowItemConfigurationTargeting
 * The list matching target_type must be non-empty; the other lists must be empty. ALL requires all three to be empty.
 * @export
 */
export type TaskWorkflowItemConfigurationTargeting = TaskWorkflowItemConfigurationTargetingOneOf | TaskWorkflowItemConfigurationTargetingOneOf1 | TaskWorkflowItemConfigurationTargetingOneOf2 | TaskWorkflowItemConfigurationTargetingOneOf3;

export function TaskWorkflowItemConfigurationTargetingFromJSON(json: any): TaskWorkflowItemConfigurationTargeting {
    return TaskWorkflowItemConfigurationTargetingFromJSONTyped(json, false);
}

export function TaskWorkflowItemConfigurationTargetingFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskWorkflowItemConfigurationTargeting {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfTaskWorkflowItemConfigurationTargetingOneOf(json)) {
        return TaskWorkflowItemConfigurationTargetingOneOfFromJSONTyped(json, true);
    }
    if (instanceOfTaskWorkflowItemConfigurationTargetingOneOf1(json)) {
        return TaskWorkflowItemConfigurationTargetingOneOf1FromJSONTyped(json, true);
    }
    if (instanceOfTaskWorkflowItemConfigurationTargetingOneOf2(json)) {
        return TaskWorkflowItemConfigurationTargetingOneOf2FromJSONTyped(json, true);
    }
    if (instanceOfTaskWorkflowItemConfigurationTargetingOneOf3(json)) {
        return TaskWorkflowItemConfigurationTargetingOneOf3FromJSONTyped(json, true);
    }
    return {} as any;
}

export function TaskWorkflowItemConfigurationTargetingToJSON(json: any): any {
    return TaskWorkflowItemConfigurationTargetingToJSONTyped(json, false);
}

export function TaskWorkflowItemConfigurationTargetingToJSONTyped(value?: TaskWorkflowItemConfigurationTargeting | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfTaskWorkflowItemConfigurationTargetingOneOf(value)) {
        return TaskWorkflowItemConfigurationTargetingOneOfToJSON(value as TaskWorkflowItemConfigurationTargetingOneOf);
    }
    if (instanceOfTaskWorkflowItemConfigurationTargetingOneOf1(value)) {
        return TaskWorkflowItemConfigurationTargetingOneOf1ToJSON(value as TaskWorkflowItemConfigurationTargetingOneOf1);
    }
    if (instanceOfTaskWorkflowItemConfigurationTargetingOneOf2(value)) {
        return TaskWorkflowItemConfigurationTargetingOneOf2ToJSON(value as TaskWorkflowItemConfigurationTargetingOneOf2);
    }
    if (instanceOfTaskWorkflowItemConfigurationTargetingOneOf3(value)) {
        return TaskWorkflowItemConfigurationTargetingOneOf3ToJSON(value as TaskWorkflowItemConfigurationTargetingOneOf3);
    }
    return {};
}

